import { authClient, API } from "../index";

// Informe en JSON
export const getReportJson = (sessionId) => {
	return authClient().get(`${API}/report/${sessionId}.json`);
};

// Informe en Excel (blob para descarga)
export const getReportXlsx = (sessionId) => {
	return authClient().get(`${API}/report/${sessionId}.xlsx`, {
		responseType: "blob",
	});
};

// Descarga el Excel abriendo un <a> temporal
export const downloadReportXlsx = async (sessionId, fileName) => {
	const res = await getReportXlsx(sessionId);
	const blob = new Blob([res.data], {
		type:
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	});
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = fileName || `informe-${sessionId}.xlsx`;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	window.URL.revokeObjectURL(url);
	return res;
};
